// This is copied in the build process in .gitlab-ci.yml.
// To test it with the development serve process,
// manually copy it to /projects/src/environments/environment.ts

// Copied from firebase console
const firebaseConfig = {
  apiKey: 'AIzaSyBq2ZDzZB3-cZ_t5H7JG1S5k_3OSkn7Oes',
  authDomain: 'leaderboard-t-online.firebaseapp.com',
  projectId: 'leaderboard-t-online',
  storageBucket: 'leaderboard-t-online.firebasestorage.app',
  messagingSenderId: '958835750706',
  appId: '1:958835750706:web:44ed2a20364e640719892b',
};

export const environment = {
  name: 't-online', // Just for information and logging purposes.
  production: true,
  firebase: firebaseConfig,
  // Needs to be here to prevent undefined bugs, but is not set, to not initialize it.
  sentry: {
    dsn: '',
  },
};
